import * as React from 'react';
import type { SVGProps } from 'react';
const SvgXCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M13.105 7.842a.493.493 0 1 0-.697-.697l-2.283 2.282-2.283-2.282a.493.493 0 0 0-.697.697l2.282 2.283-2.282 2.283a.493.493 0 0 0 .697.697l2.283-2.282 2.283 2.282a.493.493 0 1 0 .697-.697l-2.282-2.283z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M12.195 6.933a.793.793 0 0 1 1.123 1.122l-2.07 2.07 2.07 2.07a.793.793 0 1 1-1.123 1.123l-2.07-2.07-2.07 2.07a.793.793 0 1 1-1.123-1.122l2.07-2.07-2.07-2.071a.793.793 0 0 1 1.122-1.122l2.071 2.07zm-2.07 2.494L7.842 7.145a.493.493 0 0 0-.697.697l2.282 2.283-2.282 2.283a.493.493 0 0 0 .697.697l2.283-2.282 2.283 2.282a.493.493 0 1 0 .697-.697l-2.282-2.283 2.282-2.283a.493.493 0 1 0-.697-.697z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M10 16.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13m0 1.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgXCircle;
